import {
  SET_APP_ERROR,
  SET_APP_TIMEZONE,
  SET_APP_CONTAINER_WIDTH
} from '../constants/actionTypes';

export const setAppTimezone = payload => {
  return {
    type: SET_APP_TIMEZONE,
    payload
  };
};

export const setAppContainerWidth = payload => {
  return {
    type: SET_APP_CONTAINER_WIDTH,
    payload
  };
};

export const setAppError = payload => {
  return {
    type: SET_APP_ERROR,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/app.js